export const KEY_CODES = {
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  BACKSPACE: 8,
  DELETE: 46,
  END: 35,
  ENTER: 13,
  ESCAPE: 27,
  HOME: 36,
  SPACE: 32,
  SUBTRACT: 109,
  TAB: 9,
};
